import { useQuery } from "@tanstack/react-query"
import { chevronsDown } from "react-feather"
import { getFlightDetails } from "../../api/flightsAPI"
import { useAuthStore } from "../../store/authStore"
import { useEffect, useState } from "react"
import { ToastContainer } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import TextField from "../../components/UI/TextField"
import { CalculateLatLngDistance, capitalize } from "../../helpers/commonFunction"
import ShowDetailsLabel from "../../components/UI/showDetailsLabel"
import moment from "moment"
import { CaretDown } from "@carbon/icons-react"

const FlightDetails = () => {
    const { token } = useAuthStore((state) => state)
    const { flightId } = useParams();
    const [waypointDistance, setWaypointDistance] = useState(0)
    const { data, isLoading } = useQuery([token, flightId], () => getFlightDetails(flightId, token))
    const [flightData, setFlightData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (data?.data?.data) {
            setFlightData(data.data.data[0])
        }
    }, [data])

    const calculateDistance = (latLngArray) => {
        let distance = 0;
        if (latLngArray?.length > 0) {
            for (let index = 0; index < latLngArray?.length - 1; index++) {
                distance += CalculateLatLngDistance(latLngArray[index]?.lat, latLngArray[index]?.lng, latLngArray[index + 1]?.lat, latLngArray[index + 1]?.lng)
            }
        }
        setWaypointDistance(distance)
    }


    useEffect(() => {
        calculateDistance(flightData?.missionId?.waypoints)
    }, [flightData])
    return (
        <>
            <div className="p-4">
                <ToastContainer />
                <div className="flex justify-between items-center">
                    <h1 className="text-4xl w-full h-full">Flight Details</h1>
                    <div className="flex">
                        <button
                            onClick={() => navigate("/layout/flights")}
                            className="bg-tblu cursor-pointer flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                        >
                            View Flights
                        </button>
                    </div>
                </div>
                <br />
                <hr />

                {flightData && <form
                    // onSubmit={handleSubmit(submitDrone)}
                    className="grid grid-cols-2 gap-2 mt-10 leading-10"
                >
                    <ShowDetailsLabel
                        label="Flight Id"
                        value={flightData?.createdAt || ""}
                    />
                    <ShowDetailsLabel
                        label="Drone Name"
                        value={flightData?.droneId?.droneName && capitalize(flightData?.droneId?.droneName) || ""}
                    />
                    <ShowDetailsLabel
                        label="Mission Name"
                        value={flightData?.missionId?.missionName && capitalize(flightData?.missionId?.missionName) || ""}
                    />
                    <ShowDetailsLabel
                        label="Booked By"
                        value={flightData?.createdBy?.fullName && capitalize(flightData?.createdBy?.fullName) || ""}
                    />
                    <ShowDetailsLabel
                        label="Assign To"
                        value={flightData?.assignTo?.fullName && capitalize(flightData?.assignTo?.fullName) || ""}
                    />
                    <ShowDetailsLabel
                        label="Total Distance"
                        value={waypointDistance && `${waypointDistance.toFixed(2)} km` || ""}
                    />
                    <ShowDetailsLabel
                        label="Flight Start Time"
                        value={flightData?.flightStartTime && moment(flightData?.flightStartTime).format('DD/MM/YYYY hh:mm a') || ""}
                    />
                    <ShowDetailsLabel
                        label="Flight End Time"
                        value={flightData?.flightEndTime && moment(flightData?.flightEndTime).format('DD/MM/YYYY hh:mm a') || ""}
                    />
                    <ShowDetailsLabel
                        label="Flight Status"
                        value={flightData?.approvalStatus && capitalize(flightData?.approvalStatus) || ""}
                    />
                    <ShowDetailsLabel
                        label="Flight Reason"
                        value={flightData?.flightReason && capitalize(flightData?.flightReason) || ""}
                    />
                    {
                        flightData?.rejectionReason &&
                        <ShowDetailsLabel
                            label="Rejection Reason"
                            value={flightData?.rejectionReason && capitalize(flightData?.rejectionReason) || ""}
                        />
                    }
                </form>}
                <div className="pt-5 leading-6">
                    <ShowDetailsLabel
                        label="System Remarks"
                        value={flightData?.systemRemarks && capitalize(flightData?.systemRemarks) || ""}
                    />
                    {
                        flightData?.approvalStatus == "approved" ?
                            <div className="w-full">
                                <div className="flex justify-end" style={{ width: `${flightData?.flightRiskScore}%` }}>
                                    <div>
                                        <div className="font-extrabold">{flightData?.flightRiskScore}%</div>
                                        <div><CaretDown size={"24"} /></div>
                                    </div>
                                </div>
                                <div className="relative w-full h-4 bg-gray-300 rounded-full overflow-hidden">
                                    <div
                                        className="absolute w-full top-0 bottom-0 left-0 bg-gradient-to-r from-green-500 via-yellow-500 to-red-500"
                                    ></div>
                                </div>
                                <div className="w-full flex justify-between">
                                    <div>
                                        Low Risk
                                    </div>
                                    <div>
                                        Medium Risk
                                    </div>
                                    <div>
                                        High Risk
                                    </div>
                                </div>
                            </div> : ""
                    }
                </div>
            </div>
        </>
    )
}

export default FlightDetails